module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/status-removed-6531d903ef758400be41426364e3cbd9.svg";